var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"dropdown-trigger min-h-dropdown-trigger flex items-center cursor-pointer select-none",class:{ 'active': _vm.active },on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }